/**
 * created by lzy 2020.08.31
 * 新闻日历管理批量导入第一步
 */
'use strict';
angular.module('calendarImportPromptModule', []).controller('calendarImportPromptCtrl', ['$scope', '$modalInstance', 'data', 'newsCalendarManagementService',
    function($scope,  $modalInstance, data, newsCalendarManagementService) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化状态
         *
         * @return  {[type]}   [return description]
         */
        function initStatus() {
            $scope.data = {
                items: data.datas.importVOS
            }
        };
        
        /**
         * [initData description] 初始化数据
         *
         * @return  {[type]}   [return description]
         */
        function initData() {
           
        }

        /**
         * [confirm description] 确定按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.confirm = function() {
            $scope.loadingPromise = newsCalendarManagementService.saveExcelResult({excelImportKey: data.datas.excelImportKey}).then((result) => {
                result.datas.excelImportKey = data.datas.excelImportKey; // 将key传出去，在下载错误报告时使用
                $modalInstance.close(result.datas);
            })
        }

        /**
         * [close description] 取消按钮
         *
         * @return  {[type]}   [return description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        }
    }
])